import React from 'react';
import Modal from 'react-bootstrap-modal';
import TextInput from '../controls/textInput.jsx';
import InfoModal from './infoModal.jsx'

export default class FillRecipientCompanyModal extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            isOpen: false,
            title: "Данные получателя",
            recipientInn: "",
            recipientCompanyName: "",
            promiseResolve: null,
            promiseReject: null
        };

		this.infoModal = null;
    }

    open(inn, companyName) {
        let promise = new Promise((resolve, reject) => {
            this.setState({
                isOpen: true,
                recipientInn: inn,
                recipientCompanyName: companyName,
                promiseResolve: resolve,
                promiseReject: reject
            });
        });
        return promise;
    }

    close(result) {
        let data = {
            recipientInn: this.state.recipientInn,
            recipientCompanyName: this.state.recipientCompanyName
        };
        if (result) {
            this.state.promiseResolve(data);
        } else {
            this.state.promiseReject();
        }
        this.setState({
            isOpen: false,
            promiseResolve: null,
            promiseReject: null
        });
    }

    render() {
        let canSave = this.state.recipientInn && this.state.recipientCompanyName;
        return (
			<div>
				<Modal show={this.state.isOpen} 
					onHide={() => this.close(false)} 
					aria-labelledby="ModalHeader" 
					backdrop="static"
				>
					<Modal.Header closeButton>
						<Modal.Title id='ModalHeader'>
							{this.state.title}
						</Modal.Title>
					</Modal.Header>
                    <Modal.Body>
                        <div className="form-group has-feedback">
                            <label htmlFor="modalInn">ИНН получателя<span className="text-red">*</span></label>
                            <TextInput id="modalInn"
                                value={this.state.recipientInn}
                                onChange={value => this.setState({ recipientInn: value })}
                            />
                        </div>
                        <div className="form-group has-feedback">
                            <label htmlFor="modalCompany">ЮЛ получателя<span className="text-red">*</span></label>
                            <TextInput id="modalCompany"
                                value={this.state.recipientCompanyName}
                                onChange={value => this.setState({ recipientCompanyName: value })}
                            />
                        </div>
					</Modal.Body>
                    <Modal.Footer>
                        <button className='btn btn-primary' onClick={() => this.close(true)} disabled={!canSave}>
							Сохранить
						</button>
                        <Modal.Dismiss className='btn btn-default'>
							Отмена
						</Modal.Dismiss>
					</Modal.Footer>
				</Modal>

				<InfoModal ref={modal => this.infoModal = modal} />
			</div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/modals/fillRecipientCompanyModal.jsx